var AdditionalAddressController = function ($scope, $routeParams, $modalInstance, CustomerId, AdditionalAddresses, Customer, gettext, CountryStates, additionalAddress, countryWhiteListSettings, isExistingCustomer, displayedCountries) {
    $scope.CustomerId = CustomerId;
    $scope.AdditionalAddresses = AdditionalAddresses;
    $scope.tooltips = Object.freeze({
        "CountryWhitelist": gettext("The country in the address field does not match one of the countries in the whitelist. Customers that existed before the whitelist was set up can still be updated without changing the country."),
    });
    $scope.additionalAddress = {...additionalAddress};
    $scope.displayedCountries = displayedCountries;
    $scope.states = [];
    $scope.$watch('additionalAddress.Country', function () {
        if ($scope.additionalAddress != null && $scope.additionalAddress.Country != null) {
            loadStates($scope.additionalAddress.Country);
        }
    });
    $scope.close = function () {
        $modalInstance.dismiss();
    };

    $scope.temporarilySave = function () {
        $modalInstance.close($scope.additionalAddress);
    };

    $scope.save = function () {
        if (!$routeParams.contractId) {
            $modalInstance.close($scope.additionalAddress);
            return;
        }

        $scope.customer = new Customer();
        let beforeEditing;

        if (!$scope.additionalAddress.Id)
            $scope.AdditionalAddresses.push($scope.additionalAddress);
        else {
            beforeEditing = $scope.AdditionalAddresses.find(x => x.Id === $scope.additionalAddress.Id);
            $scope.AdditionalAddresses.forEach(function (item, i) {
                if (item.Id === $scope.additionalAddress.Id) $scope.AdditionalAddresses[i] = $scope.additionalAddress;
            });
        }
        $scope.customer.AdditionalAddresses = $scope.AdditionalAddresses;

        $scope.customer.$patchUpdate({ customerId: $scope.CustomerId }).then(function(response) {
            if (!$scope.additionalAddress.Id)
                $scope.additionalAddress.Id = response.AdditionalAddresses.slice(-1)[0].Id;
            $modalInstance.close($scope.additionalAddress)
        },
        function() {
            if (!$scope.additionalAddress.Id)
                $scope.AdditionalAddresses.pop();
            else
                $scope.AdditionalAddresses.forEach(function (item, i) {
                    if (item.Id === $scope.additionalAddress.Id) $scope.AdditionalAddresses[i] = beforeEditing });
        });
    };

    function loadStates(country) {
        CountryStates.getStates(country).then(function (response) {
                $scope.states = response.data.slice();
                if (!$scope.states.length) {
                    $scope.additionalAddress.State = null;
                }
            },
            function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
    }

    $scope.isCustomerCountryInWhiteList = function (currentCountry) {
        if (!isExistingCustomer && countryWhiteListSettings.IsEnabled) {
            return true;
        } else if (countryWhiteListSettings.CountryWhiteList && countryWhiteListSettings.IsEnabled && IsExistingCustomer) {
            return countryWhiteListSettings.CountryWhiteList.find(function (countryCode) {
                return countryCode.TwoLetterCode === currentCountry && countryWhiteListSettings.IsEnabled;
            });
        }
        return true;
    }
};

AdditionalAddressController.$inject = ['$scope', '$routeParams', '$uibModalInstance', 'CustomerId', 'AdditionalAddresses', 'Customer', 'gettext', 'CountryStates', "AdditionalAddress", 'CountryWhiteListSettings', 'IsExistingCustomer', 'DisplayedCountries'];
